import makeStyles from "@material-ui/core/styles/makeStyles";
import {ERROR_COLOR} from "../../../../../../../../../themes/themeConfigurator";

const styles = makeStyles((theme) => ({
  label: {
    fontSize: 12,
    '&.error': {
      color: ERROR_COLOR,
    }
  },
  icon: {
    color: theme.palette.primary.main,
    '&.error': {
      color: ERROR_COLOR,
    },
    cursor: 'pointer',
  },
  checkboxLabel: {
    fontFamily: 'Roboto-Regular'
  }
}));

export default styles;